import React from "react";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Circle, Marker, Popup } from "react-leaflet";
import L from "leaflet";

const MapWithRadius = ( {latitude, longitude, radiusKm} ) => {
//   const latitude = -33.86785;
//   const longitude = 151.20773;
//   const radiusKm = 10;

  // Создаем иконку (опционально, чтобы маркер отображался корректно)
  const markerIcon = new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

  return (
    <MapContainer
      center={[latitude, longitude]}
      zoom={10}
      scrollWheelZoom={true}
      style={{ height: "500px", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
      />

      {/* Маркер */}
      <Marker position={[latitude, longitude]} icon={markerIcon}>
        <Popup>Центральная точка</Popup>
      </Marker>

      {/* Радиус (в метрах) */}
      <Circle
        center={[latitude, longitude]}
        radius={radiusKm * 1000} // переводим км → м
        pathOptions={{ color: "blue", fillColor: "blue", fillOpacity: 0.2 }}
      />
    </MapContainer>
  );
};

export default MapWithRadius;
